import { z } from 'zod';
import { TenantSchema } from '../../../../entities/tenant/tenant.schema';
/**
 * A tenant row as returned by the list endpoint. `memberCount` and
 * `processCount` are non-deleted headcounts of the tenant's own users and
 * processes — both are surfaces for future license limits.
 */ export const TenantListItemSchema = TenantSchema.extend({
    memberCount: z.number().int().nonnegative(),
    processCount: z.number().int().nonnegative()
});
/**
 * List Tenants Response Schema
 * GET /api/v2/tenants
 * Returns an array of all tenants in the system
 * Restricted to super-admin users only
 */ export const ListTenantsResponseSchema = z.object({
    tenants: z.array(TenantListItemSchema)
});

//# sourceMappingURL=list-tenants.schema.js.map